import { StreamActions } from "@hotwired/turbo"

StreamActions.dispatch_event = function() {
  const eventName = this.getAttribute("event")
  if (eventName) {
    window.dispatchEvent(new CustomEvent(eventName, { bubbles: true }))
  }
}